# Graphics Engine Configuration

{/* ## Logs

This will download the Logs for the Graphics Engine as a TXT file. */}

## Start/Stop

Starts the Graphics Engine. Only displays when the Graphics Engine is running.
Stops the Graphics Engine. Only displays when the Graphics Engine is not running.

## Restart

Restarts the Graphics Engine if it is already running, else this button is disabled.

## Eco Options

## Enable Eco Period

Shuts down the Graphics Engine between certain times to save power.

## Startup Configuration

### Enable Splash Screens on Startup

Displays the CanvasPro SplashScreens on the Graphics Engine output for each Frame. (Each Splashscreen is coloured the same as the Frame it represents). This can be useful for debugging frame position and size during startup.

Disabling this will keep the Frames black until the first Frame is rendered. Useful in scenarios where the screens face a public space where the SplashScreens are not desired.

### Automatically start Runtime

Will start the Runtime when CanvasPro starts. (check?)
